var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loki-cards-graph"},[_c('b-row',{staticStyle:{"margin-bottom":"2rem"}},_vm._l((_vm.cards),function(card,index){return _c('b-col',{key:index,class:index >= 3 ? 'mt-4' : '',attrs:{"cols":"6","md":"4"}},[_c('app-card',{attrs:{"data":card}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }